/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetImportPreviewQueryResponse,
  GetImportPreviewPathParams,
  GetImportPreview404,
} from '../types/GetImportPreview'

function getGetImportPreviewUrl({
  import_number,
}: {
  import_number: GetImportPreviewPathParams['import_number']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/${import_number}/` as const,
  }
  return res
}

/**
 * @summary Get an import preview with its full data payload
 * {@link /api/v1/importengine/previews/v2/:import_number/}
 */
export async function getImportPreview(
  {
    import_number,
  }: { import_number: GetImportPreviewPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetImportPreviewQueryResponse,
    ResponseErrorConfig<GetImportPreview404>,
    unknown
  >({
    method: 'GET',
    url: getGetImportPreviewUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
